import Inputmask from "maskedinput";

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.js-mask-money').forEach((element, key, parent) => {
        let im = new Inputmask({alias: "currency", prefix: '', groupSeparator: ' ', digits: 0});
        im.mask(element);
    })
});
